import { useNavigate } from "react-router-dom";
import { dismissSetupBanner } from "../lib/setupState";

type SetupFinishBannerProps = {
  customerId: string;
  onDismiss?: () => void;
};

export default function SetupFinishBanner({
  customerId,
  onDismiss,
}: SetupFinishBannerProps) {
  const navigate = useNavigate();

  const handleDismiss = () => {
    dismissSetupBanner(customerId);
    onDismiss?.();
  };

  return (
    <div
      className="mb-6 flex flex-col gap-3 rounded-xl border px-4 py-3 sm:flex-row sm:items-center sm:justify-between"
      style={{
        background: "rgba(138, 43, 226, 0.12)",
        borderColor: "rgba(138, 43, 226, 0.35)",
      }}
      role="status"
    >
      <p
        className="text-sm text-white"
        style={{ fontFamily: "'Space Grotesk', sans-serif" }}
      >
        Your setup isn&apos;t finished yet — connect your line so NeuroSphere can answer calls.
      </p>
      <div className="flex items-center gap-2 shrink-0">
        <button
          type="button"
          onClick={() => navigate("/setup")}
          className="rounded-lg px-4 py-2 text-sm font-semibold text-white cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-400 focus-visible:ring-offset-2 focus-visible:ring-offset-[#0b0b0f]"
          style={{
            background: "linear-gradient(90deg, #8a2be2, #ff6a00)",
            fontFamily: "'Space Grotesk', sans-serif",
          }}
        >
          Finish setting up →
        </button>
        <button
          type="button"
          onClick={handleDismiss}
          className="rounded-lg px-2.5 py-2 text-gray-400 hover:text-white cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-400"
          aria-label="Dismiss setup reminder"
        >
          <i className="ri-close-line text-lg" aria-hidden />
        </button>
      </div>
    </div>
  );
}
